import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Box, Button, Card, TextField, Typography } from "@mui/material";
import { ConstructionOutlined } from "@mui/icons-material";
import axios from "axios";
import { serializedChatSonic } from "../utils/CommonUtils";
import parse from "html-react-parser";
import { fetchEventSource } from "@microsoft/fetch-event-source";

const axiosApiInstance = axios.create();

const httpEndpoint = "https://api.writesonic.com/v1/content/chatsonic";

const serialize = (obj) => {
  var str = [];
  for (var p in obj)
    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
  return str.join("&");
};

const ChatSection = () => {
  const [questionText, setQuestionText] = useState("");
  const [answer, setAnswer] = useState("answer");
  const [incoming, setIncoming] = useState("");

  useEffect(() => {
    setAnswer(answer.toString() + incoming.toString());
  }, [incoming]);

  // vc06999 WriteSonic@vc06999#
  // const queryParam = `https://api.writesonic.com/v1/content/chatsonic/sse?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjM4NDk5MjVlLTc0YjEtNDU5NS05ZjlkLTgxYzlhODNiMGU3MSIsImV4cCI6MTY4MTE3MTYxMX0.zoMqod-xTtbwaKTR2x_buGP-8V3abzguaS85Do9Nz9w&data=%7B%22seed_text%22%3A%22${questionText}%22%2C%22show_web_results%22%3Afalse%2C%22history_id%22%3A%2221a56b36-b2bd-404b-822d-832a91647afc%22%2C%22selected_image_vendor%22%3A%22stable-diffusion%22%2C%22personality_id%22%3A%225a35e647-5e32-4bce-9a8d-2911981b20fb%22%2C%22selected_location%22%3A%22United+States%22%2C%22enable_memory%22%3Atrue%2C%22enable_detailed%22%3Afalse%2C%22prompt_id%22%3Anull%2C%22number_memory_messages%22%3A2%2C%22engine_id%22%3A%22e01fa28b-3554-426d-8c52-d9be166f623f%22%7D`
  const getAnswer = async () => {
    setAnswer("Loading . . .");
    const queryParam = `token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6ImM4NDU2NDk1LWQ1OTYtNDU2NC1hYjMyLTIzZTFmMjQ5OTg0ZSIsImV4cCI6MTY4MDk4MjIxM30.nakLO3YhycoN3qwjGyR_i0_s4EVt8eeIAVgCUtTumdE&data=%7B%22seed_text%22%3A%22${questionText}%22%2C%22show_web_results%22%3Afalse%2C%22history_id%22%3A%22ed4ea9e0-11ba-4c2c-8c86-19c6a9385c82%22%2C%22selected_image_vendor%22%3A%22stable-diffusion%22%2C%22personality_id%22%3A%225a35e647-5e32-4bce-9a8d-2911981b20fb%22%2C%22selected_location%22%3A%22United+States%22%2C%22enable_memory%22%3Atrue%2C%22enable_detailed%22%3Afalse%2C%22prompt_id%22%3Anull%2C%22number_memory_messages%22%3A2%2C%22engine_id%22%3A%22e01fa28b-3554-426d-8c52-d9be166f623f%22%7D`;
    // await fetchEventSource(`/api/sse`, {
    await fetchEventSource(`${httpEndpoint}/sse?${queryParam}`, {
      onmessage(ev) {
        console.log(ev.data);
        setIncoming(ev.data.toString());
      },
    });

    // const response = axiosApiInstance.get(`${httpEndpoint}/sse?${queryParam}`, {
    //   headers: { "Access-Control-Allow-Origin": "*" },
    // });
    // const { data } = await response;
    // console.log("data");
    // console.log(data);
    // const serializedResults = serializedChatSonic(data);
    // setAnswer("");
    // serializedResults.forEach((el, i) => {
    //   console.log(el);
    //   if (el.event.trim() === "update") {
    //     setTimeout(() => {
    //       setIncoming(el.data.toString());
    //     }, 100 * i);
    //   }
    // });
  };

  return (
    <>
      <Card sx={{ width: "100%" }}>
        <TextField
          id="outlined-basic"
          label="Outlined"
          variant="outlined"
          fullWidth
          value={questionText}
          onChange={(evt) => setQuestionText(evt.target.value)}
        />
      </Card>
      <Box textAlign="center">
        <Button variant="contained" onClick={getAnswer}>
          Send
        </Button>
      </Box>
      {/* {parse({ answer })} */}
      {answer}
    </>
  );
};

const f = () => {};

export { ChatSection, f };
